export enum FIELDS {
  SUBJECT = 'subject',
  REASON_SUBREASON = 'reasonSubreason',
  STATUS = 'status',
  CREATED_AT_MIN = 'createdAtMin',
  CREATED_AT_MAX = 'createdAtMax',
}
